import BasicLayout from '@/layout/BasicLayout.vue'

const tpmRouter = {
  path: '/tpm',
  component: BasicLayout,
  children: [
    {
      path: '/tpm/device-resume',
      component: () => import('../../views/tpm/device-resume/index.vue'),
    },
    {
      path: '/tpm/maintain-records',
      component: () => import('../../views/tpm/maintainRecords/index'),
    },
    {
      path: '/tpm/maintain-plans',
      component: () => import('../../views/tpm/maintainPlans/index'),
    },
    {
      path: '/tpm/check-record',
      component: () => import('../../views/tpm/check-record/index.vue'),
    },
    {
      path: '/tpm/repair-apply',
      component: () => import('../../views/tpm/repair-apply/index'),
    },
    {
      path: '/tpm/repair-record',
      component: () => import('../../views/tpm/repair-record/index'),
    },
    {
      path: '/tpm/warning',
      component: () => import('../../views/tpm/warning/index.vue'),
    },
  ],
}

export default tpmRouter
